/*
 * Native Possum — np-eu-delivery.js (v4)
 * Behaviour for snippets/np-eu-delivery.liquid (see its header), in the bag
 * drawer and on the cart page. Loaded deferred from layout/theme.liquid.
 *
 * For every [data-np-eu-delivery] block:
 *   - DDP or DAP: the EUR cart total (cents, data-total) at or over
 *     NP_SHIPPING.eu.ddpLimitEUR → DAP. v2: the EU shipping zones are priced
 *     in EUR with the same cut-off, so no currency conversion here.
 *   - DAP estimate: VAT % (data-vat) × (total + standard DAP shipping, EUR)
 *     + €3 duty per item type + local fee (data-fee, €).
 *   - The tick box: saved as the cart attribute
 *     "EU delivery charges acknowledged" (npCart.attributes); every copy on
 *     the page (bag desktop + mobile, cart) follows the one ticked.
 *   - v4 DDP-only countries (data-ddp-only, theme setting np_eu_ddp_only):
 *     always DDP, at any cart value (v3's "cap" state removed).
 * window.npEuDelivery.allowCheckout(scope): false (and the error shown, the
 * box focused) when a DAP block in scope isn't ticked. Called by
 * np-bag-drawer.js checkout() and np-cart-page.js on submit.
 * Re-runs on np:cart:updated (np-cart.js swaps the Liquid markup).
 * Depends on: np-cart.js (npCart), np-utilities.js (npFormatMoney).
 */
(function () {
  'use strict';

  var ATTR = 'EU delivery charges acknowledged';

  function settings() {
    var eu = (window.NP_SHIPPING && window.NP_SHIPPING.eu) || {};
    return {
      limit: eu.ddpLimitEUR || 0,          // EUR cents
      dapShip: eu.dapShippingEUR || 0      // EUR cents
    };
  }

  // 'ddp' | 'dap' (v4: DDP-only countries are always 'ddp')
  function modeOf(block) {
    var s = settings();
    if (!s.limit || block.hasAttribute('data-ddp-only')) return 'ddp';
    var total = parseInt(block.getAttribute('data-total'), 10) || 0;
    return total >= s.limit ? 'dap' : 'ddp';
  }

  function estimateText(block) {
    var s = settings();
    var total = parseInt(block.getAttribute('data-total'), 10) || 0;
    var vatPct = parseFloat(block.getAttribute('data-vat')) || 0;
    var fee = parseFloat(block.getAttribute('data-fee')) || 0;
    var vat = Math.round((total + s.dapShip) * vatPct / 100);
    var text = 'You’ll pay approx. ' + window.npFormatMoney(vat) + ' VAT + ' +
      window.npFormatMoney(300) + ' duty per item type';
    if (fee > 0) text += ' + ' + window.npFormatMoney(Math.round(fee * 100)) + ' local fee';
    return text + ' on delivery';
  }

  function render(block) {
    var mode = modeOf(block);
    ['ddp', 'dap'].forEach(function (m) {
      var el = block.querySelector('[data-np-eu-state="' + m + '"]');
      if (el) el.hidden = m !== mode;
    });
    block.setAttribute('data-np-eu-mode', mode);
    if (mode === 'dap') {
      var est = block.querySelector('[data-np-eu-estimate]');
      if (est) est.textContent = estimateText(block);
    }
  }

  function renderAll() {
    document.querySelectorAll('[data-np-eu-delivery]').forEach(render);
  }

  function setError(box, on) {
    var block = box.closest('[data-np-eu-delivery]');
    var err = block ? block.querySelector('[data-np-eu-error]') : null;
    if (err) {
      err.hidden = !on;
      if (on) err.setAttribute('role', 'alert');
      else err.removeAttribute('role');
    }
    if (on) box.setAttribute('aria-invalid', 'true');
    else box.removeAttribute('aria-invalid');
  }

  function onChange(e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches('[data-np-eu-ack]')) return;
    var checked = box.checked;
    document.querySelectorAll('[data-np-eu-ack]').forEach(function (other) {
      other.checked = checked;
      if (checked) setError(other, false);
    });
    if (window.npCart && window.npCart.attributes) {
      var attrs = {};
      attrs[ATTR] = checked ? 'Yes (' + new Date().toISOString().slice(0, 10) + ')' : '';
      window.npCart.attributes(attrs, { source: 'eu-ack' }).catch(function () {});
    }
  }

  // false = a DAP block in scope isn't ticked (error shown, box focused)
  function allowCheckout(scope) {
    var root = scope || document;
    var blocks = Array.prototype.slice.call(root.querySelectorAll('[data-np-eu-delivery]'));
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      render(block);
      if (block.getAttribute('data-np-eu-mode') !== 'dap') continue;
      // The bag has a desktop and a mobile copy; only the one on screen counts.
      if (!block.offsetParent && blocks.length > 1) continue;
      var box = block.querySelector('[data-np-eu-ack]');
      if (box && !box.checked) {
        setError(box, true);
        box.focus();
        return false;
      }
    }
    return true;
  }

  document.addEventListener('change', onChange);
  document.addEventListener('np:cart:updated', renderAll);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAll);
  } else {
    renderAll();
  }

  window.npEuDelivery = { allowCheckout: allowCheckout, render: renderAll };
})();
